<template>
    <Details ref="postDetail" />
</template>
<script>
    import Details from './index/postDetail'
    export default {
        components: {
            Details
        },
        beforeRouteEnter (to, from, next) {
            next(vm => {
                vm.$nextTick(()=>{
                    console.log(1)
                    vm.$refs.postDetail.init();
                })
            })
        },
    }
</script>